import { render } from "./TrashView.vue?vue&type=template&id=5d5fc7c0"
import script from "./TrashView.vue?vue&type=script&lang=js"
export * from "./TrashView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__